import { render, staticRenderFns } from "./playLayout.vue?vue&type=template&id=3097407b&scoped=true&"
import script from "./playLayout.vue?vue&type=script&lang=ts&"
export * from "./playLayout.vue?vue&type=script&lang=ts&"
import style0 from "./playLayout.vue?vue&type=style&index=0&id=3097407b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3097407b",
  null
  
)

export default component.exports